import { FormEvent, useState } from 'react';
import { SiteButton } from '../site/SiteButton';
import { CONTACT_FORM_POINTS } from '../../data/contact';

export function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  function handleSubmit(e: FormEvent) {
    e.preventDefault();

    if (!name.trim() || !email.includes('@') || !message.trim()) {
      setStatus('error');
      return;
    }

    setStatus('success');
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
  }

  return (
    <div className="contact-form-card reveal-item">
      <span className="contact-form-card__tag">Send a message</span>
      <h2 className="contact-form-card__title">Tell us about your interest</h2>
      <p className="contact-form-card__description paragraph-02 text-dark-grey-two">
        Whether you are raising capital, looking to invest, or exploring the platform, we are here to help.
      </p>

      <ul className="contact-form-card__points">
        {CONTACT_FORM_POINTS.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>

      <div className="contact-form-card__divider" />

      <form className="contact-form" onSubmit={handleSubmit} noValidate>
        <div className="contact-form__row">
          <div className="contact-form__group">
            <label className="contact-form__label" htmlFor="contact-name">
              Name
            </label>
            <input
              id="contact-name"
              className="contact-form__input"
              type="text"
              name="name"
              placeholder="Your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="contact-form__group">
            <label className="contact-form__label" htmlFor="contact-email">
              Email
            </label>
            <input
              id="contact-email"
              className="contact-form__input"
              type="email"
              name="email"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="contact-form__group">
          <label className="contact-form__label" htmlFor="contact-subject">
            Subject
          </label>
          <input
            id="contact-subject"
            className="contact-form__input"
            type="text"
            name="subject"
            placeholder="Early access, partnership, or support"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>

        <div className="contact-form__group">
          <label className="contact-form__label" htmlFor="contact-message">
            Message
          </label>
          <textarea
            id="contact-message"
            className="contact-form__input contact-form__textarea"
            name="message"
            placeholder="Tell us about your interest in Hello Gwiji"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>

        <div className="contact-form-card__divider contact-form-card__divider--submit" />

        <div className="contact-form__submit">
          <SiteButton type="submit">Send message</SiteButton>
        </div>

        {status === 'success' && (
          <p className="contact-form__msg contact-form__msg--success" role="status">
            Thanks for reaching out. We will get back to you soon.
          </p>
        )}
        {status === 'error' && (
          <p className="contact-form__msg contact-form__msg--error" role="alert">
            Please fill in your name, a valid email, and a message.
          </p>
        )}
      </form>
    </div>
  );
}
